export const FONT_SIZES = [
  '8px',
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '28px',
  '32px',
  '36px',
  '40px',
];

export const AXIS_LABEL_SIZE = 40;
export const AXIS_LABEL_PADDING = 24;
